module.exports = __webpack_public_path__ + "static/media/twitchTV.a7629a34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/twitchTV.jpg
// module id = 77
// module chunks = 0